import { render, staticRenderFns } from "./yumijiaoyou.vue?vue&type=template&id=08aae674&scoped=true&"
import script from "./yumijiaoyou.vue?vue&type=script&lang=js&"
export * from "./yumijiaoyou.vue?vue&type=script&lang=js&"
import style0 from "./yumijiaoyou.vue?vue&type=style&index=0&id=08aae674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aae674",
  null
  
)

export default component.exports